import { FraudReportReferenceData, FraudReportSearchFiltersState } from "@idw-types/state/fraud-report-state";
import { FormattedAssertionFraudResult } from "@idw-types/data/assertion-fraud-result";

export enum FraudReportActionTypes {
    // Reference Data
    SET_FRAUD_REPORT_REFERENCE_DATA_LOADING = "SET_FRAUD_REPORT_REFERENCE_DATA_LOADING",
    SET_FRAUD_REPORT_REFERENCE_DATA = "SET_FRAUD_REPORT_REFERENCE_DATA",
    // Search
    SET_FRAUD_REPORT_SEARCH_FILTERS = "SET_FRAUD_REPORT_SEARCH_FILTERS",
    SET_FRAUD_REPORT_SEARCH_RESULTS_LOADING = "SET_FRAUD_REPORT_SEARCH_RESULTS_LOADING",
    SET_FRAUD_REPORT_SEARCH_RESULTS = "SET_FRAUD_REPORT_SEARCH_RESULTS",
    // Export
    SET_FRAUD_REPORT_EXPORT_LOADING = "SET_FRAUD_REPORT_EXPORT_LOADING"
}

// Reference Data
type SetFraudReportReferenceDataLoadingAction = {
    type: FraudReportActionTypes.SET_FRAUD_REPORT_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean }
};

export const setFraudReportReferenceDataLoading = (isLoading: boolean): SetFraudReportReferenceDataLoadingAction => ({
    type: FraudReportActionTypes.SET_FRAUD_REPORT_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetFraudReportReferenceDataAction = {
    type: FraudReportActionTypes.SET_FRAUD_REPORT_REFERENCE_DATA,
    payload: { referenceData: FraudReportReferenceData; }
};

export const setFraudReportReferenceData = (referenceData: FraudReportReferenceData): SetFraudReportReferenceDataAction => ({
    type: FraudReportActionTypes.SET_FRAUD_REPORT_REFERENCE_DATA,
    payload: { referenceData }
});

// Search
type SetFraudReportSearchFiltersAction = {
    type: FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_FILTERS;
    payload: { searchFilters: FraudReportSearchFiltersState };
};

export const setFraudReportSearchFilters = (searchFilters: FraudReportSearchFiltersState): SetFraudReportSearchFiltersAction => ({
    type: FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetFraudReportSearchResultsLoadingAction = {
    type: FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setFraudReportSearchResultsLoading = (isLoading: boolean): SetFraudReportSearchResultsLoadingAction => ({
    type: FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetFraudReportSearchResultsAction = {
    type: FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_RESULTS;
    payload: { assertionFraudResults: Array<FormattedAssertionFraudResult> };
};

export const setFraudReportSearchResults = (assertionFraudResults: Array<FormattedAssertionFraudResult>): SetFraudReportSearchResultsAction => ({
    type: FraudReportActionTypes.SET_FRAUD_REPORT_SEARCH_RESULTS,
    payload: { assertionFraudResults }
});

// Export
type SetFraudReportExportLoadingAction = {
    type: FraudReportActionTypes.SET_FRAUD_REPORT_EXPORT_LOADING,
    payload: { isLoading: boolean };
};

export const setFraudReportExportLoading = (isLoading: boolean): SetFraudReportExportLoadingAction => ({
    type: FraudReportActionTypes.SET_FRAUD_REPORT_EXPORT_LOADING,
    payload: { isLoading }
});

export type FraudReportActions =
    // Reference Data
    SetFraudReportReferenceDataLoadingAction |
    SetFraudReportReferenceDataAction |
    // Search
    SetFraudReportSearchFiltersAction |
    SetFraudReportSearchResultsLoadingAction |
    SetFraudReportSearchResultsAction |
    // Export
    SetFraudReportExportLoadingAction